module.exports = __webpack_public_path__ + "img/Avatar-11.81da2005.svg";